<template>
  <div class="home">
      <Payment class="marginal" :value="1"></Payment>
  </div>
</template>

<script>
import Payment from '@/components/Payment.vue';
export default {
  name: 'PaymentPage',
  components: {
    Payment
  }
}
</script>